import { ReactNode, useState } from "react";

import { useAppVersionGate } from "../../hooks/useAppVersionGate";

import ForcedUpdateScreen from "./ForcedUpdateScreen";
import SuggestedUpdateScreen from "./SuggestedUpdateScreen";

interface Props {
  children: ReactNode;
}

// Children are ALWAYS rendered. The Forced/Suggested screens render on
// top as fullscreen overlays via FullScreenMobilePage's
// `position: absolute; z-index: 100; inset: 0`. Critical: never replace
// children with the screens, because that would unmount the entire
// router tree (LoginPage, ProtectedRoute, in-flight auth listeners) and
// break flows like login → external browser → auth callback. The user
// dismissing "Más tarde" must not remount the app.
const AppVersionGate = ({ children }: Props) => {
  const { status, platformInfo } = useAppVersionGate();
  const [dismissed, setDismissed] = useState(false);

  return (
    <>
      {children}
      {status === "forced" && <ForcedUpdateScreen platformInfo={platformInfo} />}
      {status === "suggested" && !dismissed && (
        <SuggestedUpdateScreen
          platformInfo={platformInfo}
          onDismiss={() => setDismissed(true)}
        />
      )}
    </>
  );
};

export default AppVersionGate;
